export default __webpack_public_path__ + "static/media/logo-comune.93c619a5.jpg";